import React from 'react';
import {Route, useParams} from 'react-router-dom';
import {renderRoutes} from 'react-router-config';

// import Main from './components/menus/main';
// import Header from './components/menus/header';
// import SearchModal from "./components/menus/search";
import MainMenu from './components/menus/MainMenu';
import FencesContainer from './components/fence/FencesContainer/FencesContainer';
import {LocatingModal} from './components/modals/locating-modal';
import TimeLine from './components/menus/Timeline2';
import {FlashMessage, PremiumFlash} from './components/elements/flash-message';
import {getPublicViewRoutes, getRoutes} from './routes';
import {useRedux} from './states/redux-state';
import {useIsLocating, LOCATION_STATUS} from './stores/reducers/general-reducers';
import {GmapComponent} from './components/gmaps';
import FabMenu from './components/elements/FabMenu';
import {CloseButtonStreetView} from './components/elements/CloseButtonSteetView';
import {MapLegendWrapper} from './components/gmaps';

import './standard-desktop-layout.scss';
import {GMapModal} from './components/GMapModal';
import {useSelector} from "react-redux";
import {iFullStoreState} from "./shared/interfaces";
import {ACL, UserCan} from "./shared/constants";
import {history} from "./stores/store";

/*
export const StandardDesktopLayout = () => {
    return <div style={{display: 'flex', flexDirection: 'column', height: '100%', alignItems: 'stretch', position: 'relative'}}>
        <SearchModal />
        <div className="header-wrapper" style={{zIndex: 3, flexGrow: 0}}><Header /></div>
        <div style={{flexGrow: 1, display: 'flex', overflow: 'hidden'}}>
            <div style={{zIndex: 3, flexGrow: 0}}>
                <Main />
            </div>
            <MainContent />
        </div>
    </div>;
};
*/

export const StandardDesktopLayout = (): JSX.Element => {
    const IS_PUBLIC_VIEW = useRedux((s) => s.auth.isPublic) || window.location.href.includes('public-view');
    return (
        <div className="desktop-layout">
            {!IS_PUBLIC_VIEW && <MainMenu />}
            <MainContent />
        </div>
    )};

const MainContent = (): JSX.Element=> {
    const IS_PUBLIC_VIEW = useRedux((s) => s.auth.isPublic) || window.location.href.includes('public-view');
    const isDriver = useRedux((s) => s.auth.isDriver);
    const publicTagId = localStorage.getItem('public-view-tag-id') || undefined;
    const userCanDo = useSelector<iFullStoreState, Array<string>>(
        s => s.auth.user?.acl?.can
    );
    const showTags = ACL.check(UserCan.SEE_TAGS, userCanDo, true);
    const seeAllReports = ACL.check(UserCan.SEE_ALL_REPORTS, userCanDo, true);
    const routes = IS_PUBLIC_VIEW
        ? getPublicViewRoutes(publicTagId)
        : getRoutes({[UserCan.SEE_ALL_REPORTS]: seeAllReports, [UserCan.SEE_TAGS]: showTags});
    return (
        <div className="main-content">
            {renderRoutes(routes, {isDriver})}
            <div className="google-map-block">
                {!isDriver && <NonModalPagePortion />}
                <GmapComponent />
                <CloseButtonStreetView />
                <GMapModal />
            </div>
        </div>
    );
};
const NonModalDevicePortion = (): JSX.Element => {
    const {deviceId} = useParams<{ deviceId: string }>();
    const [locateStatus] = useIsLocating(deviceId);

    const isStreetView = useRedux((s) => !!s.gmap.streetViewLocation);

    return <>
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{zIndex: 1, maxHeight: 0}}>
                {
                    isStreetView ?
                        <div /> :
                        locateStatus === LOCATION_STATUS.ACTIVE ?
                            <LocatingModal /> :
                            <FlashMessage />
                }
                <PremiumFlash />
            </div>
        </div>
    </>;
};

const NonModalPagePortion = React.memo(() => {
    const isStreetView = useRedux((s) => !!s.gmap.streetViewLocation);
    const isGeoFenceContainerVisible = useSelector((s: iFullStoreState) => s.fencesContainerUI.isGeoFenceContainerVisible);

    return <>
        <FabMenu />
        <Route path="/device/:deviceId">
            <NonModalDevicePortion />
        </Route>
        <Route exact path="/device">
            <MapLegendWrapper />
        </Route>
        <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end', maxHeight: 'calc(100% - 150px)'}}>
            {
                !isStreetView &&
                <Route path={['/tags', '/:itemType/:itemId', '/device', /* , '/reports/:reportType(static|travel)'*/]}>
                    {isGeoFenceContainerVisible && <FencesContainer style={{zIndex: 1, margin: '70px 20px 50px'}} />}
                </Route>
            }
        </div>
    </>;
});
